import { EntityQuery, FilterQueryOp } from 'breeze-client';
import { DraftBookmark } from '../../models';

const baseQuery = EntityQuery.from('DraftBookmarks');
const defaultDraftBookmark = baseQuery.where(DraftBookmark.propName('isDefault'), FilterQueryOp.Equals, true);

export const draftBookmarkQueries = {
  selectAll: baseQuery,
  selectDefaultDraftBookmark: defaultDraftBookmark
};
